export const POOL_ADDRESSES_PROVIDER = '0x5C6C6ab99afDa79865e57a12c025B0Ad355276aC';
export const POOL = '0x5425afD90Bd1AAD68d5bADCB80390101a2750bc5';
export const UI_POOL_DATA_PROVIDER = '0xb9d350537A63B7e5cb02B44e230e093C0abB2707';
export const WALLET_BALANCE_PROVIDER = '0xD9B5d5D7b1B57d6aC447E5dE6DB742ad041f8C45';
export const WETH_GATEWAY = '0x7BD23152D7005e9a3048A2Ea74A686C579794D69';
export const FALLBACK_FLASHLOAN_PROVIDER = '0x89B63Fe61bC96E91B4245e1a9E32940579EBd4c9';
export const PREFERRED_FLASHLOAN_PROVIDERS = [];
export const ASSET_CONVERTER = '0xb41704dA807e8d9B5A1E685263ab2349a5bf39e7';
export const CHAIN_ID = 8453;
